<script setup lang="ts">
import { ref } from 'vue';
import {
  Button, Modal, Spin,
} from 'ant-design-vue';

import useFileContentServiceCreateMutation from './useFileContentServiceCreateMutation';

import AlertError from '@/ui/NoDataUrql/AlertError.vue';

defineProps<{ fileId: number }>();

const modalOpen = ref(false);
const { fetching, error, runCreate, runCreateAsync } = useFileContentServiceCreateMutation();

const openModal = () => {
  modalOpen.value = true;
};

const closeModal = () => {
  if (!fetching.value) {
    modalOpen.value = false;
  }
};
</script>

<template>
  <Button type="primary" @click="openModal">
    Run File Content
  </Button>
  <Modal
    title="Run File Content"
    :open="modalOpen"
    :footer="null"
    width="480px"
    @cancel="closeModal"
  >
    <Spin :spinning="fetching">
      <p class="mb-4 text-gray-600">
        This calls the server to extract text from the file linked to this table. It may take a while.
      </p>
      <AlertError v-if="error" :error="error" class="mb-4" />
      <div class="flex justify-end gap-2">
        <Button :disabled="fetching" @click="closeModal">
          Close
        </Button>
        <Button
          type="primary"
          :loading="fetching"
          @click="() => runCreate(fileId)"
        >
          Run extraction
        </Button>
        <Button
          type="primary"
          :loading="fetching"
          @click="() => runCreateAsync(fileId)"
        >
          Run extraction async
        </Button>
      </div>
    </Spin>
  </Modal>
</template>
